DiscussionsService = function (addOnUuid, elementId, groupId, anchor, addOnUrl, loginUrl) {
    this._addOnUuid = addOnUuid;
    this._elementId = elementId;
    this._groupId = groupId;
    this._anchor = anchor;
    this._addOnUrl = addOnUrl;
    this._loginUrl = loginUrl;

    this._discussionComponent = new DiscussionsFrame({
        div_id: elementId,
        ref_id: addOnUuid,
        group_id: groupId,
        sticky_header_height: 50,
        anchor: anchor,
        debug: false,
        base_url: addOnUrl,
        callbacks: {
          onUrl: null,
          onLogin: this._loginCallback.bind(this),
          onReply: this._replyCallback.bind(this)
        }
      });
};

DiscussionsService.prototype.load = function () {
    this._discussionComponent.initComments();
};

DiscussionsService.prototype._loginCallback = function () {
    window.location = this._loginUrl;
};

DiscussionsService.prototype._replyCallback = function (data) {
    let topicReplyCount = data.topic_reply_count;
    if (typeof topicReplyCount !== 'undefined') {
        let counterElements = document.querySelectorAll('[data-counter-id =' + this._anchor + ']');
        for (let i = 0; i < counterElements.length; i++) {
            counterElements[i].innerHTML = `(${topicReplyCount})`;
        }
    }
};

